export default [
    {
      path: "/billing-collection/overview",
      name: "BCM_overview",
      component: () => import("@/views/3pl/BillingandCollection/Overview"),
    },
    {
      path: "/billing-collection/all-transaction",
      name: "BCM_alltransaction",
      component: () => import("@/views/3pl/BillingandCollection/Overview/AllTransaction"),
    },
    {
      path: "/billing-collection/estimate",
      name: "BCM_estimate",
      component: () => import("@/views/3pl/BillingandCollection/Estimates"),
    },
    {
      path: "/billing-collection/recievables",
      name: "BCM_recievables",
      component: () => import("@/views/3pl/BillingandCollection/Recievables"),
    },
    {
      path: "/billing-collection/collections",
      name: "BCM_collections",
      component: () => import("@/views/3pl/BillingandCollection/Collections"),
    },
    {
      path: "/billing-collection/settlements",
      name: "BCM_settlements",
      component: () => import("@/views/3pl/BillingandCollection/Settlements"),
    },
    {
      path: "/billing-collection/reciept/:id",
      name: "BCM_reciept",
      component: () => import("@/views/3pl/BillingandCollection/Reciept"),
    },
    {
      path: "/billing-collection/transactionview/:id",
      name: "Transaction_View",
      component: () => import("@/views/3pl/BillingandCollection/Reciept/TransactionView.vue"),
    },
    {
      path: "/billing-collection/invoice/:id",
      name: "BCM_invoice",
      component: () => import("@/views/3pl/BillingandCollection/Reciept/Invoice"),
    },
    {
      path: "/billing-collection/billreciept/:id",
      name: "BCM_Billreciept",
      component: () => import("@/views/3pl/BillingandCollection/Reciept/BillReciept"),
    },
    {
      path: "/billing-collection/earnreciept/:id",
      name: "EARN_Billreciept",
      component: () => import("@/views/3pl/BillingandCollection/Reciept/EarnReciept"),
    },
    {
      path:"/billing-and-payments/earning_payout",
      name:"EarningAndPayout",
      component: () => import("@/views/3pl/BillingandCollection/EarnAndPayment/index.vue")
    },
     {
      path:"/billing-and-payments/earn_payout",
      name:"EarnAndPayout",
      component: () => import("@/views/3pl/BillingandCollection/EarningAndPayout/index.vue")
    },
    {
      path: "/billing-collection/send_quote/:id",
      name: "BCM_Send_Quote",
      component: () => import("@/views/3pl/BillingandCollection/Reciept/SendQuote"),
    },
  ];
  